export default "__VITE_ASSET__DDW_FKMs__"